import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlertIcon, AlertService, AuthService, LoadingPanelService, VisorComponent } from 'lib-base';
import { firstValueFrom, forkJoin, Subscription } from 'rxjs';
import { WebContribuyenteService } from '../../services/webContribuyenteService.service';

@Component({
  selector: 'app-registrar-firma-electronica',
  standalone: true,
  imports: [VisorComponent],
  template: `
  <app-visor></app-visor>
  `
})
export class RegistrarFirmaElectronicaComponent implements OnInit, OnDestroy, AfterViewInit {

  private _codigo !: string;

  @ViewChild(VisorComponent) visorDialog !: VisorComponent;
  private _visorButton1Subscription !: Subscription;
  private _visorButton2Subscription !: Subscription;

  translations: any = {};
  constructor(private _a: AuthService, private _t: TranslateService, private _wc: WebContribuyenteService, private _lps: LoadingPanelService,
    private alertService: AlertService
  ) {
  }

  ngOnInit() {
    this.translate()
  }

  ngAfterViewInit(): void {
    this._visorButton1Subscription = this.visorDialog.button1Source$.subscribe(obj => {
      this.registrarSolicitudFirmaElectronica();
    });
    this._visorButton2Subscription = this.visorDialog.button2Source$.subscribe(obj => {
      this._a.logout().subscribe({ next: (response) => { } });
    });
  }

  ngOnDestroy(): void {
    if (this._visorButton1Subscription) {
      this._visorButton1Subscription.unsubscribe();
    }
    if (this._visorButton2Subscription) {
      this._visorButton2Subscription.unsubscribe();
    }
  }

  private async translate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      warnSummary: this._t.get('form.msg.warn-summary'),
      registrarExito: this._t.get('components.app-authentication-manager.register-form.registrar-exito'),
      aceptar: this._t.get('form.button.aceptar'),
      siguiente: this._t.get('form.button.siguiente'),
      campoRequerido: this._t.get('form.msg.campo-requerido'),
      sugerencias: this._t.get('components.app-activar-usuario.sugerencias'),
      contrasena: this._t.get('form.password.contrasena'),
      constasenaNoCoiniciden: this._t.get('form.password.constasena-no-coiniciden'),
      repitaContrasena: this._t.get('form.password.repita-contraseña'),
      alMenosUnaMinuscula: this._t.get('form.password.al-menos-una-minuscula'),
      alMenosUnaMayuscula: this._t.get('form.password.al-menos-una-mayuscula'),
      alMenosUnNumero: this._t.get('form.password.al-menos-un-número'),
      minimoCaracteres: this._t.get('form.password.minimo-caracteres'),
      maximoCaracteres: this._t.get('form.password.maximo-caracteres'),
      alMenosUnCaracterEspecial: this._t.get('form.password.al-menos-un-caracter-especial'),
      cambiarContrasena: this._t.get('form.password.cambiar-contrasena'),
      visorDialogTitle: this._t.get('components.app-activar-usuario.visorDialog-title'),
      codigoActivacionValidoNoValido: this._t.get('components.app-activar-usuario.codigo-activacionValido-no-valido'),
      registrarSolicitudTitle: this._t.get('components.app-activar-usuario.registrar-solicitud-title'),
      registrarSolicitudHtml: this._t.get('components.app-activar-usuario.registrar-solicitud-html'),
      cancelar: this._t.get('form.button.cancelar'),
    }));
  }

  documentoSolicitudFirmaElectronica(codigo: string) {
    this._codigo = codigo;
    this._wc.documentoSolicitudFirmaElectronica().subscribe({
      next: (response: Blob) => {
        if (response.size > 0) {
          this.visorDialog.title = this.translations.visorDialogTitle;
          this.visorDialog.button1Label = this.translations.aceptar;
          this.visorDialog.button2Label = this.translations.cancelar;
          this.visorDialog.showDialog(response);
        }
      }
    });
  }

  registrarSolicitudFirmaElectronica() {
    this._lps.show(true);
    this._wc.registrarSolicitudFirmaElectronica(this._codigo).subscribe({
      next: (response: string) => {
        this._wc.enviarCorreoSolicitudFirmaElectronica().subscribe({
          next: (response: string) => {
            this._lps.hide();
            this.alertService.show({
              icon: AlertIcon.SUCCESS,
              title: this.translations.registrarSolicitudTitle,
              text: this.translations.registrarSolicitudHtml,
              showAccept: true,
              textAccept: this.translations.aceptar
            }).subscribe((event)=>{
              this._a.logout().subscribe({ next: (response) => { } });
            });
          }
        });
      }
    });
  }
}
